export const siteConfig = {
  name: 'NEXAIGEN',
  description: 'Digital Solutions for UK Small Businesses',
  tagline: 'Helping UK Small Businesses Grow Online',
  url: 'https://nexaigen.co.uk',
  email: 'info@nexaigen.co.uk',
  phone: '+447887711224',
  address: {
    street: 'London',
    city: 'London',
    country: 'United Kingdom',
  },
  social: {
    twitter: 'https://twitter.com/nexaigen',
    linkedin: 'https://linkedin.com/company/nexaigen',
    facebook: 'https://facebook.com/nexaigen',
    instagram: 'https://instagram.com/nexaigen',
  },
  navigation: [
    { name: 'Home', href: '/' },
    { name: 'Services', href: '/services' },
    { name: 'How It Works', href: '/process' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' },
  ],
  services: [
    {
      id: 'web-development',
      name: 'Websites',
      shortDescription: 'Get a professional website that works for your business 24/7',
      description: 'We build beautiful, fast websites that help customers find you and buy from you. Whether you need a simple business website or an online shop, we make it easy.',
      icon: 'Globe',
      features: [
        'Works on all devices (mobile, tablet, desktop)',
        'Online booking & contact forms',
        'Online shop with secure payments',
        'Easy to update yourself',
      ],
      price: 'From £499',
    },
    {
      id: 'mobile-apps',
      name: 'Mobile Apps',
      shortDescription: 'Your own app for iPhone and Android',
      description: 'Give your customers a better experience with a mobile app. Perfect for restaurants, salons, gyms, and any business that wants to stay connected with customers.',
      icon: 'Smartphone',
      features: [
        'Works on iPhone & Android',
        'Push notifications to customers',
        'Online ordering & booking',
        'Loyalty programs & rewards',
      ],
      price: 'From £1,499',
    },
    {
      id: 'seo',
      name: 'SEO',
      shortDescription: 'Get found on Google when customers search for your services',
      description: 'We help your business appear at the top of Google search results. When someone searches for what you offer, they find YOU instead of your competitors.',
      icon: 'Search',
      features: [
        'Appear on Google Maps',
        'Rank higher in search results',
        'Get more website visitors',
        'Monthly reports showing progress',
      ],
      price: 'From £199/month',
    },
    {
      id: 'social-marketing',
      name: 'Social Media',
      shortDescription: 'Build your brand on Facebook, Instagram & more',
      description: 'We manage your social media so you can focus on running your business. We create posts, respond to comments, and run ads that bring in new customers.',
      icon: 'BarChart3',
      features: [
        'Regular posts on your social media',
        'Eye-catching graphics & videos',
        'Facebook & Instagram ads',
        'Monthly reports & insights',
      ],
      price: 'From £299/month',
    },
  ],
  process: [
    {
      step: 1,
      title: 'Free Chat',
      description: 'Tell us about your business. What do you do? What are your goals? We listen and understand your needs. No pressure, no obligation.',
    },
    {
      step: 2,
      title: 'Custom Plan',
      description: 'We create a plan just for you. You will see exactly what we will build, how long it takes, and how much it costs. No surprises.',
    },
    {
      step: 3,
      title: 'We Build It',
      description: 'Our team gets to work. You see progress every step of the way. We ask for your feedback to make sure you love the result.',
    },
    {
      step: 4,
      title: 'Launch & Support',
      description: 'We launch your project and train you to use it. We are always here to help if you need us. Your success is our success.',
    },
  ],
  whyChooseUs: [
    {
      title: 'Made for Small Business',
      description: 'We understand small business. No confusing tech jargon. Just simple solutions that work.',
    },
    {
      title: 'Fair Pricing',
      description: 'No hidden fees. You know exactly what you pay for. Flexible payment plans available.',
    },
    {
      title: 'UK Based Support',
      description: 'We are based in the UK. Call or email us anytime. Real people, real help.',
    },
    {
      title: 'Results Guaranteed',
      description: 'Not happy? We will make it right. We only succeed when you succeed.',
    },
  ],
  testimonials: [
    {
      name: 'Sarah Johnson',
      business: 'The Corner Bakery',
      location: 'Manchester',
      quote: 'NEXAIGEN built our website and now we get online orders every day. Our sales went up 40% in 3 months!',
      rating: 5,
    },
    {
      name: 'James Patel',
      business: 'Patel Dental Care',
      location: 'Birmingham',
      quote: 'Our new booking system saved us hours every week. Patients love how easy it is to book appointments online.',
      rating: 5,
    },
    {
      name: 'Emma Williams',
      business: 'Williams Hair Studio',
      location: 'London',
      quote: 'The social media management has been brilliant. We have gained over 2,000 new followers and bookings are up!',
      rating: 5,
    },
  ],
  stats: [
    { value: '200+', label: 'Happy Customers' },
    { value: '98%', label: 'Satisfaction Rate' },
    { value: '24h', label: 'Response Time' },
    { value: '5 Star', label: 'Google Rating' },
  ],
} as const

export type Service = (typeof siteConfig.services)[number]
export type ProcessStep = (typeof siteConfig.process)[number]
